/* eslint-disable */
export const ACTIVE_SEND_EMAIL = 'ACTIVE_SEND_EMAIL'; //发送邮件
export const ACTIVE_SEND_SUCCESS = 'ACTIVE_SEND_SUCCESS'; //发送成功
export const ACTIVE_SEND_ERR = 'ACTIVE_SEND_ERR'; //发送失败

export const ACTIVE_CHANGE_CODE_IMG = 'ACTIVE_CHANGE_CODE_IMG'; //更改验证码
